<ng-template #refresh>
    <app-component-loading size="inline"></app-component-loading>
</ng-template>

<div class="panel">
        @for (user of users; track user.member.guid) {
            <app-contract-avatar  
                    [avatarSize]="'36px'" 
                    [userGuid]="user.member.guid" 
                    [matTooltip]="user.tooltip"
                    > 
            </app-contract-avatar>
        }
</div>